import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";

// Pages
import PublicResultsPage from "./pages/PublicResultsPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminLayout from "./pages/AdminLayout";
import DashboardPage from "./pages/DashboardPage";
import UploadStudentsPage from "./pages/UploadStudentsPage";
import UploadResultsPage from "./pages/UploadResultsPage";
import ViewStudentsPage from "./pages/ViewStudentsPage";
import ViewResultsPage from "./pages/ViewResultsPage";
import ProgramsPage from "./pages/ProgramsPage";

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<PublicResultsPage />} />
            
            {/* Admin Auth */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            
            {/* Protected Admin Routes */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<DashboardPage />} />
              <Route path="upload-students" element={<UploadStudentsPage />} />
              <Route path="upload-results" element={<UploadResultsPage />} />
              <Route path="students" element={<ViewStudentsPage />} />
              <Route path="results" element={<ViewResultsPage />} />
              <Route path="programs" element={<ProgramsPage />} />
            </Route>

            {/* Catch all - redirect to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </AuthProvider>
  );
}

export default App;
